import isEmpty from 'utils/isEmpty';

const productNameSanitize = (productName, productBrand) => {
  let replaced = productName.replace(
    /nước hoa nam|nước hoa nữ|nước hoa unisex|nước hoa/gi,
    ''
  );
  replaced = replaced.replace(productBrand, '');
  return replaced;
};

export default productNameSanitize;
